import React from 'react'
import PropTypes from 'prop-types'
import { FormControlLabel, Checkbox as MuiCheckbox } from '@mui/material'
import { Controller } from 'react-hook-form'
import { Tooltip } from '@mui/material_modern'

const Checkbox = ({
  name,
  label,
  control,
  defaultValue,
  disabled,
  tooltipText,
  onChange: onChangeProp,
  noMargin,
  ...restProps
}) => (
  <Tooltip title={tooltipText || ''}>
    <FormControlLabel
      sx={{
        ...(noMargin ? { margin: 0 } : {}),
        '& .MuiFormControlLabel-label': {
          color: 'text.primary',
        },
      }}
      control={
        <Controller
          name={name}
          control={control}
          disabled={disabled}
          defaultValue={defaultValue}
          render={({ field: { onChange, value } }) => (
            <MuiCheckbox
              checked={value || false}
              defaultValue={defaultValue}
              onChange={e => {
                onChange(e.target.checked)
                if (onChangeProp) {
                  onChangeProp(e)
                }
              }}
              disabled={disabled}
              {...restProps}
            />
          )}
        />
      }
      label={label}
    />
  </Tooltip>
)

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.bool,
  control: PropTypes.instanceOf(Object).isRequired,
  disabled: PropTypes.bool,
  tooltipText: PropTypes.string,
}

Checkbox.defaultProps = {
  defaultValue: false,
  disabled: false,
}

export default Checkbox
